import React, { useState, useEffect } from 'react';
import ResourceCard from './ResourceCard';
import { TextField, MenuItem, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';


const ResourcePage = ({ resources }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTag, setSelectedTag] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [filteredResources, setFilteredResources] = useState(resources);

  useEffect(() => {
    const filtered = resources.filter(resource =>
      resource.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (selectedTag ? resource.tag === selectedTag : true) &&
      (selectedLocation ? resource.location === selectedLocation : true)
    );
    setFilteredResources(filtered);
  }, [resources, searchQuery, selectedTag, selectedLocation]);

  const uniqueTags = Array.from(new Set(resources.map(resource => resource.tag)));
  const uniqueLocations = Array.from(new Set(resources.map(resource => resource.location)));

  return (
    <div>
      <div className="search-and-filter-bar">
        <TextField
          label="Search resource"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          style={{ flex: 2.5, marginRight: 10 }}
        />
        <TextField
          select
          fullWidth
          variant="outlined"
          size="small"
          value={selectedTag}
          onChange={(e) => setSelectedTag(e.target.value)}
          label="Tags"
          style={{ flex: 1, marginRight: 10 }}
        >
          <MenuItem value="">
            <em>All Tags</em>
          </MenuItem>
          {uniqueTags.map((tag) => (
            <MenuItem key={tag} value={tag}>
              {tag}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          fullWidth
          variant="outlined"
          size="small"
          value={selectedLocation}
          onChange={(e) => setSelectedLocation(e.target.value)}
          label="Locations"
          style={{ flex: 1, marginRight: 10 }}
        >
          <MenuItem value="">
            <em>All Locations</em>
          </MenuItem>
          {uniqueLocations.map((location) => (
            <MenuItem key={location} value={location}>
              {location}
            </MenuItem>
          ))}
        </TextField>
      </div>
      <div className="resource-gallery">
        {filteredResources.map(resource => (
          <ResourceCard key={resource.name} resource={resource} />
        ))}
      </div>
    </div>
  );
};

export default ResourcePage;
